import storage from 'helpers/storage';

const KEY = 'loginData';

export const loginDataService = {
  get: () => JSON.parse(storage.get(KEY) || null),
  set: (data) => storage.set(KEY, JSON.stringify(data)),
  clear: () => storage.remove(KEY),
};

export default loginDataService;
